import Select from './src/JsmSelect.vue'

Select.install = (Vue) => {
  Vue.component(Select.name, Select)
}

export default Select
